module.exports = __webpack_public_path__ + "img/introcover.cce10d6c.jpg";